<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <span class="sa-flexbox-body-title">Schede Programma Riabilitativo</span>
                <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" class="mb-2" @click="onClickAggiungi">
                    <i class="fas fa-plus"></i>
                    Aggiungi
                </b-button>
                <b-table v-if="items.length > 0" sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(createDate)="{ item }">
                        <span>{{ formatDateTime(item.createDate) }}</span>
                    </template>
                    <template v-slot:cell(updateDate)="{ item }">
                        <span>{{ formatDateTime(item.updateDate) }}</span>
                    </template>
                    <template #cell(action)="{ item }">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover class="mr-1 ml-1 no-text" size="sm" variant="outline-secondary width-sm no-text" title="Visualizza" aria-label="Visualizza" @click="onClickVisualizzaScheda(item)">
                                <i class="fas fa-eye"></i>
                            </b-button>
                            <b-button v-b-tooltip.hover class="mr-1 ml-1 no-text" size="sm" variant="outline-success width-sm no-text" title="Modifica" aria-label="Modifica" @click="onClickModificaScheda(item)">
                                <i class="fas fa-edit"></i>
                            </b-button>
                            <b-button v-b-tooltip.hover class="mr-1 ml-1 no-text" size="sm" variant="outline-danger width-sm no-text" title="Elimina" aria-label="Elimina" @click="onClickDeleteScheda(item)">
                                <i class="fas fa-trash"></i>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
                <NoDataComponent v-else ref="cmpNoDataComponent" title="Non sono presenti Schede Programma Riabilitativo per il paziente" nome="no-data" subtitle="" icon="fas fa-users" />
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info mx-2">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <rsa-paziente-scheda-programma-riabilitativo-modal-edit
            ref="cmpProgrammaRiabilitativoModal"
            @beforeLoadData="$emit('beforeLoadData')"
            @afterLoadData="$emit('afterLoadData')"
            @afterSave="onAfterSave"
        ></rsa-paziente-scheda-programma-riabilitativo-modal-edit>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaPazienteSchedaProgrammaRiabilitativoModalEdit from "./RsaPazienteSchedaProgrammaRiabilitativoModalEdit.vue";
import NoDataComponent from "../../../../template/components/utility/NoDataComponent.vue";

export default {
    name: "RsaPazienteSchedaProgrammaRiabilitativoListComponent",
    mixins: [UtilityMixin],
    components: { RsaPazienteSchedaProgrammaRiabilitativoModalEdit, NoDataComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsaschedaprogrammariabilitativo",
            filtroProgrammaRiabilitativo: {
                idAccettazione: null,
            },
            idAccettazione: null,
            items: [],
            fields: [
                {
                    label: "Data compilazione",
                    key: "createDate",
                    sortable: true,
                },
                {
                    label: "Setting riabilitativo",
                    key: "settingRiabilitativo",
                    sortable: true,
                },
                {
                    label: "Ultima modifica",
                    key: "updateDate",
                    sortable: true,
                },
                {
                    label: "",
                    key: "action",
                    class: "sa-table-column-action-double",
                },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        onClickAggiungi() {
            this.$refs.cmpProgrammaRiabilitativoModal.show(this.idAccettazione);
        },
        onAfterSave() {
            this.loadData();
        },
        init(idAccettazione) {
            let me = this;
            me.idAccettazione = idAccettazione;
            me.loadData();
        },
        loadData() {
            let me = this;

            me.$emit("beforeLoadData");
            me.filtroProgrammaRiabilitativo.idAccettazione = me.idAccettazione;
            me.filtroProgrammaRiabilitativo.page = me.currentPage;
            me.filtroProgrammaRiabilitativo.forPage = me.perPage;
            me.loadDataResources(me.pathResource, me.filtroProgrammaRiabilitativo, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            me.items = [];
            me.rows = 0;
            me.$emit("afterLoadData");
            let messaggio = error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : error.message;
            me.$bvToast.toast(messaggio || "Errore durante il caricamento delle schede", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onClickVisualizzaScheda(item) {
            this.$refs.cmpProgrammaRiabilitativoModal.visualizzaScheda(item);
        },
        onClickModificaScheda(item) {
            this.$refs.cmpProgrammaRiabilitativoModal.modificaScheda(item);
        },
        onClickDeleteScheda(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Scheda",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteScheda(item.id);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteScheda(id) {
            let me = this;
            me.$emit("beforeLoadData");
            me.deleteResource(me.pathResource + "/" + id, me.deleteSchedaSuccess, me.deleteSchedaError);
        },
        deleteSchedaSuccess() {
            let me = this;
            me.loadData();
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteSchedaError(error) {
            let me = this;
            me.$emit("afterLoadData");
            let messaggio = error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : "Errore durante l'eliminazione";
            me.$bvToast.toast(messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>

